import React, { useState, useEffect } from "react";
import { useStyles } from "../../assets/jss/ContentDetails";
import {
    getSession,
    getUserData,
    getUserRBAC,
    logOutUser,
} from "../../services/LocalStorageService";
import CustomPaper from "../../components/CustomComponents/CustomPaper/CustomPaper";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import { Helmet } from "react-helmet";
import ErrorAlert from "../../components/ErrorAlert/ErrorAlert";
import qs from "querystring";
import ContentDetailsTab from "../../components/ContentDetailsTab/ContentDetailsTab";
import { EntityAccess, RBAC_CODE, Role } from "../../config/app-globals.enum";
import heroImage from "../../assets/images/contentDetail.svg";
import {
    getContentDetails,
    getContentFromOldUrl,
} from "../../services/ContentDetails";
import CustomCircularProgress from "../../components/CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { useHistory } from "react-router-dom";
import {
    isUserLoggedIn,
    setRequstUrl,
} from "../../services/LocalStorageService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function ContentDetailsView(props) {
    const params = useParams();

    const { t } = useTranslation();
    const [getRBAC_ContentView] = React.useState(
        getUserRBAC(RBAC_CODE.CONTENT_VIEW, props)
    );
    const [getRBAC_ContentPreview] = React.useState(
        getUserRBAC(RBAC_CODE.CONTENT_PREVIEW, props)
    );
    const [isLoggedIn] = React.useState(isUserLoggedIn(props));
    const [userData] = useState(getUserData);
    const [userSession] = React.useState(getSession);
    const [isApiFailed, setIsApiFailed] = useState(false);
    const [isApi, setIsApi] = useState(false);
    const [content, setContent] = useState(null);
    const [showTab, setShowTab] = useState(t("EMAIL"));
    const [isDriver, setIsDriver] = useState(false);
    const [showTabIndex, setShowTabIndex] = useState(0);
    const classes = useStyles();
    const [googleAnalyticsId] = React.useState(process.env.REACT_APP_GOOGLE_TAG_ID);
    const [contentIdParam, setContentIdParam] = useState(null);
    const [userOldIdParam, setUserOldIdParam] = useState(null);
    const [userOldIdParamExist, setUserOldIdParamExist] = useState(false);
    const [emailTokenParam, setEmailTokenParam] = useState(null);
    const [emailTokenParamExist, setEmailTokenParamExist] = useState(null);
    const [mobileTokenParam, setMobileTokenParam] = useState(null);
    const [mobileTokenParamExist, setMobileTokenParamExist] = useState(null);
    const history = useHistory();
    useEffect(() => {
        if (props) {
            setContentIdParam(
                props.match.params.id
                    ? props.match.params.id
                    : props.match.params.contentId
                        ? props.match.params.contentId
                        : null
            );
            if (props.match.params.userOldId) {
                setUserOldIdParamExist(true);
                setUserOldIdParam(props.match.params.userOldId);
            }
            const queryParams = qs.parse(props.location.search);
            // @todo: need to replace qs with urlsearchparams
            // const queryParamsData = new URLSearchParams(props.location.search);
            // const queryParams = Object.fromEntries(queryParamsData)
            setEmailTokenParam(
                queryParams["?et"] ? queryParams["?et"] : null
            );
            setMobileTokenParam(
                queryParams["?mobileToken"] ? queryParams["?mobileToken"] : null
            );
            setEmailTokenParamExist(queryParams["?et"] ? true : false);
            setMobileTokenParamExist(queryParams["?mobileToken"] ? true : false);
        }
    }, [props]);

    useEffect(() => {
        async function getContentFromOldData() {
            setStatusValue(null);
            setIsApi(true);
            setAlertMessage("");
            setIsAlertOpen(false);
            const data = await getContentFromOldUrl({
                contentId: contentIdParam,
                userId: userOldIdParam ? userOldIdParam : null,
            }, params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsApi(false);
                setIsApiFailed(false);
                setUserOldIdParam(null);
                setUserOldIdParamExist(false);
                setContentIdParam(data.content.contentId);
                // history.push(`/contents/${data.content.contentId}`);
                if (data.content.contentId) {
                    if (isLoggedIn) {
                        if (params.impersonationid) {
                            history.push(`/impersonation/${params.impersonationid}/contents/${data.content.contentId}`);
                        } else {
                            history.push(`/contents/${data.content.contentId}`);
                        }
                    } else {
                        if (params.impersonationid) {
                            setRequstUrl({
                                hash: "",
                                pathname: `/impersonation/${params.impersonationid}/contents/${data.content.contentId}`,
                                search: "",
                            });
                        } else {
                            setRequstUrl({
                                hash: "",
                                pathname: `/contents/${data.content.contentId}`,
                                search: "",
                            });
                        }
                    }
                }
            } else {
                setIsApi(false);
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }
        if (userOldIdParamExist) {
            getContentFromOldData();
        } else {
            if (
                emailTokenParamExist === true ||
                emailTokenParamExist === false ||
                mobileTokenParamExist === true ||
                mobileTokenParamExist === false
            ) {
                if (userData || emailTokenParam || mobileTokenParam) {
                    setShowTab(t("EMAIL"));
                    setShowTabIndex(0);
                    // @todo: Need to verify, what if admin loggedin from mobile app
                    setIsDriver(
                        (getRBAC_ContentPreview && getRBAC_ContentPreview.isAccessible !== EntityAccess.ALLOWED) ||
                            emailTokenParamExist ||
                            mobileTokenParamExist
                            ? true
                            : false
                    );
                }
            }
        }
    }, [
        userData,
        emailTokenParam,
        emailTokenParamExist,
        mobileTokenParam,
        mobileTokenParamExist,
        userOldIdParam,
        userOldIdParamExist,
    ]);

    //====
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    React.useEffect(() => {
        async function getContent() {
            setStatusValue(null);
            setIsApi(true);
            setAlertMessage("");
            setIsAlertOpen(false);
            const data = await getContentDetails({
                contentId: contentIdParam,
                mobileToken: mobileTokenParamExist ? mobileTokenParam : null,
                emailToken: emailTokenParamExist ? emailTokenParam : null,
                isPreview: isDriver ? false : true,
            }, params);

            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsApi(false);
                setIsApiFailed(false);
                setContent(data.content.content);
            } else {
                setIsApi(false);
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
                setTimeout(() => {
                    if (data && data.status.code === 1002) {
                        if (params.impersonationid) {
                            history.push(`/impersonation/${params.impersonationid}/engagement`);
                        } else {
                            history.push("/engagement");
                        }
                    } else if (
                        data &&
                        (data.status.code === 401)
                    ) {
                        logOutUser();
                    } else {
                        if (params.impersonationid) {
                            history.push(`/dashboard/impersonation/${params.impersonationid}`);
                        } else {
                            history.push("/dashboard");
                        }
                    }
                }, 1000);
            }
        }
        if (
            ((userSession && contentIdParam) ||
                mobileTokenParamExist ||
                emailTokenParamExist) &&
            typeof isDriver === "boolean"
        ) {
            getContent();
        }
    }, [userSession, contentIdParam, isDriver]);

    return (
        <>
            <CustomGrid container spacing={0} justifyContent="space-between">
                <CustomGrid item md={12}>
                    {getRBAC_ContentPreview &&
                        getRBAC_ContentPreview.isAccessible === EntityAccess.ALLOWED ? (
                        <CustomTypography
                            component="h5"
                            variant="h2"
                            className={classes.message}
                        >
                            {t("THIS_IS_PREVIEW")}
                        </CustomTypography>
                    ) : null}
                </CustomGrid>
            </CustomGrid>
            <CustomPaper elevation={0} className={classes.contentDetailsWrapper}>
                <CustomGrid
                    container
                    spacing={0}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <CustomGrid item xs={12} md={4}>
                        <img style={{ maxWidth: "90%" }} src={heroImage} />
                    </CustomGrid>
                    {isApi && (
                        <CustomGrid item xs={12} md={8}>
                            <CustomCircularProgress />
                        </CustomGrid>
                    )}
                    {!isApi && !isApiFailed && (
                        <>
                            <CustomGrid item xs={12} md={8}>
                                <CustomBox
                                    display="flex"
                                    flexWrap="wrap"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    mb={3}
                                >
                                    {content && (
                                        <CustomBox>
                                            <CustomTypography
                                                component="h1"
                                                variant="h5"
                                                className={classes.title}
                                            >
                                                {content.emailSubjectLine}
                                            </CustomTypography>
                                        </CustomBox>
                                    )}
                                </CustomBox>

                                <ContentDetailsTab
                                    showTab={showTab}
                                    showTabIndex={showTabIndex}
                                    isDriver={isDriver}
                                    content={content}
                                    mobileTokenParam={mobileTokenParam}
                                />
                            </CustomGrid>
                        </>
                    )}
                </CustomGrid>
            </CustomPaper>

            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />

            <Helmet>
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
                ></script>
                <script>
                    {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', "${googleAnalyticsId}");
        `}
                </script>
            </Helmet>
        </>
    );
}
